import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme.busbud;

  return {
    container: {
      display: "grid",
      gridTemplateAreas: "'start middle end'",
      gridTemplateColumns: `${spacing(10)} ${spacing(3)} minmax(0, 1fr)` // `minmax` prevents grid blowout.
    },
    slotStart: {
      gridArea: "start"
    },
    slotMiddle: {
      gridArea: "middle"
    },
    slotEnd: {
      gridArea: "end",
      paddingRight: spacing(1),
      paddingLeft: spacing(1)
    },
    hasIndent: {
      paddingBottom: spacing(2.5)
    }
  };
});
